import { ModalHeader, Text } from '@livechat/design-system-react-components'

const ActivateProductHeader = () => (
  <ModalHeader title="One last thing">
    <Text size="sm">App installation almost complete.</Text>
  </ModalHeader>
)

export default ActivateProductHeader
